import axios from "axios";

const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL || "https://bsglobalventures.com/backend";

export const API_URLS = {
  inquirySubmit: `${BACKEND_URL}/api/inquiry/submit.php`,
  inquiryList: `${BACKEND_URL}/api/inquiry/list.php`,
  inquiryDetail: (id) => `${BACKEND_URL}/api/inquiry/detail.php?id=${id}`,
  authLogin: `${BACKEND_URL}/api/auth/login.php`,
  authMe: `${BACKEND_URL}/api/auth/me.php`,
};

export const API = `${BACKEND_URL}/api`;
export const api = axios.create();

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bsg_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;

  const method = (config.method || "get").toLowerCase();
  const url = config.url || "";

  if (url === "/auth/me" || url === `${API}/auth/me`) {
    config.url = API_URLS.authMe;
  } else if (url === "/auth/login" || url === `${API}/auth/login`) {
    config.url = API_URLS.authLogin;
  } else if ((url === "/inquiry" || url === `${API}/inquiry`) && method === "post") {
    config.url = API_URLS.inquirySubmit;
  } else if ((url === "/inquiry" || url === `${API}/inquiry`) && method === "get") {
    config.url = API_URLS.inquiryList;
  } else {
    const match = url.match(/^\/(?:api\/)?inquiry\/([^/?]+)$/);
    if (match && method === "get") {
      config.url = API_URLS.inquiryDetail(match[1]);
    }
  }

  return config;
});

export const formatApiError = (detail) => {
  if (!detail) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return String(detail);
};
